export default (guestName, roomNumber, passcode) => {
  return `
Welcome to J-Honor, ${guestName}!!

When do you expect to arrive our hostel?

Your room number is "${roomNumber}".
Your passcode for your room is "${passcode}"
(You should touch the screen to activate keypad, then press the passcode. Don't forget to press * at the end to open the door.)

Check In : Wednesday, October 2 “16:00”
Check Out : Saturday, October 5 “10:00”
* Early Check In, Late Check Out = 5000won/hour
* Please throw out all your trash in “luggage store room(first floor)” when you check out :sunglasses:

If you arrive before check in time you could leave your luggage in the “luggage store room(first floor)“, but please let us know before.

Korean address : 서울시 중구 소공로6나길 8
English address: 8, Sogong-ro 6na-gil, Jung-gu, Seoul, Republic of Korea
Map Link: http://kko.to/gLQCR8E0T
(Please “DO NOT use Google Maps” as it is not accurate in Korea. Use Kakao Map instead)
Android: https://play.google.com/store/apps/details?id=net.daum.android.map&hl=en
iOS: https://apps.apple.com/us/app/kakaomap-korea-no-1-map/id304608425

If you take a taxi, show this message to the driver :
게스트하우스 손님입니다. 우선 네비게이션에 “B마이게스트하우스“를 치고 오시고 오신 뒤, 좌측 언덕으로 올라와서 우측 골목으로 들어와주세요. 들어오시면 우측에 파란색 간판 J Honor guesthouse에 내려주시면 됩니다.(소공로6나길 )

All free wifi(Any wifi name with jhonor)
passcode: 77777777

*Notice
1. This is a SMOKE-FREE guesthouse. $500 smoking fee will be charged for smoking in the guest rooms or in the building.
2. If you pollute the bedspreads or towels, unfortunetly we will need to charge you a cleaning fee (oil stain, cosmetics, blood, food etc).
3. All noise complaints which resulted in compensation to guests disturbed will be charged to the guest room whose noise caused the complaint and will have the right to expel.
4. Do not wear your shoes inside the room.
5. Do not exceed the standard number of people. If you violate this we will charge you $100 fine.
6. We don’t offer parking space.
7. We don’t provide toothbrush / toothpaste, please bring your own.
* early checkin, late checkout = 5000won/hour *

Instruction to our J-Honor

# Incheon Airport Bus No. 6015
(Drop : Myeongdong station)
https://www.airport.kr/ap/en/tpt/busRouteList.do
Fare : 15000 KRW per person
Time to Myeongdong : 80minutes.
Working hour : AM 05:40- 22:55(airport departure)
Gate:
1) Terminal 1
Bus No. 6015 at Gate 5B or 12A.
2) Terminal 2
Bus No. 6015 at Gate 28

Late bus : N6001 AM 00:15-04:40
6A-4 (only to Seoul Station)

# Incheon Airport Train
Around 5000KRW per person
ICN -> Seoul Station -> Myeongdong station (Airport Railroad Express -> Line 4)
Make sure to buy a ticket to Myeongdong station.

# Gimpo Airport Bus No. 6021
Stop : Myeongdong
06:00 - 21:00

* Walk 7minute from Myeongdong station.
Myeongdong station -> our hostel(copy url and open in new browser) :
https://youtu.be/523knykZ3nc
  `;
};
